export default "__VITE_ASSET__D2WGySE1__"